import React from 'react';
import { NetworkPrompt } from './NetworkPrompt';
import { useChain, useCorrectNetwork } from '@sc1/common';

export const RequireNetwork = ({
  children,
}: {
  children: any;
}): JSX.Element | null => {
  const chain = useChain();

  const isCorrectNetwork = useCorrectNetwork(chain);

  if (!isCorrectNetwork) return <NetworkPrompt chain={chain} />;
  return children || '';
};
